import { useState } from "react";
import moment from "moment";
import { useIntl } from "react-intl";
import StaticTable from "../StaticTable/StaticTable";
import DateToolTip from "../DateToolTip/DateToolTip";
import useHover from "../../hooks/useHover";
import Tooltip from "../Tooltip/Tooltip";
import ConfigDetailsPopUp from "./ConfigDetailsPopUp";
import Skeleton from "react-loading-skeleton";

const ConsentProcessing = ({ details, loading }) => {
  const intl = useIntl();
  const [selectedConsent, setSelectedConsent] = useState();
  const [isProfileHistoryOpen, setIsProfileHistoryOpen] = useState(false);
  const { handleMouseEnter, handleMouseLeave, hoveredData, ishovered } =
    useHover();

  const columns = [
    {
      header: intl.formatMessage({
        id: "id.label.purpose-key",
        defaultMessage: "Purpose Key",
      }),
      accessorKey: "purpose_key",
    },
    {
      header: intl.formatMessage({
        id: "id.label.expiration-period",
        defaultMessage: "Expiration Period",
      }),
      accessorKey: "expiration_period",
      cell: (info) => {
        const value = info.getValue();
        if (value === null) {
          return "-";
        } else {
          return value;
        }
      },
    },
    {
      header: intl.formatMessage({
        id: "id.label.expiration-pattern",
        defaultMessage: "Expiration Pattern",
      }),
      accessorKey: "expiration_pattern",
    },
    {
      header: intl.formatMessage({
        id: "id.label.languages",
        defaultMessage: "Languages",
      }),
      accessorKey: "languages",
    },
    {
      header: intl.formatMessage({
        id: "id.label.main-identity-model",
        defaultMessage: "Main Identity Model",
      }),
      accessorKey: "main_identity_model",
    },
    {
      header: () => {
        return (
          <Tooltip position="right" text={"Date format: DD.MM.YYYY"}>
            <span className="pe-1">
              {intl.formatMessage({
                id: "id.label.major-change-effective-date",
                defaultMessage: "Major Change Effective Date",
              })}
            </span>
          </Tooltip>
        );
      },

      accessorKey: "major_change_effective_datetime",
      cell: (info) => {
        const value = info.getValue();
        if (value === null) {
          return "N/A";
        }
        if (moment(value).isValid()) {
          return (
            <div
              onMouseEnter={() => handleMouseEnter(value)}
              onMouseLeave={handleMouseLeave}
              className="d-flex align-items-center"
            >
              <span className="pe-1">
                {moment.utc(value).local().format("DD.MM.YYYY HH:mm")}
              </span>
              <DateToolTip ishovered={ishovered} hoveredData={hoveredData} />
            </div>
          );
        }
        return "Invalid Date";
      },
    },
    {
      header: intl.formatMessage({
        id: "id.label.purpose-description",
        defaultMessage: "Purpose Description",
      }),
      accessorKey: "purpose_description",
    },
  ];
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 col-lg-12 px-0">
            <div className="custom-border">
              {loading ? (
                <table className="table loading-table" style={{ marginTop: "10px" }}>
                  <tbody>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((row) => (
                      <tr key={row}>
                        {[1, 2, 3, 4, 5, 6, 7]?.map((col) => (
                          <td key={col}>
                            <Skeleton animation="wave" variant="text" />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <StaticTable
                  columns={columns}
                  data={details}
                  customClass={"consent-processing"}
                  defaultErrorMessage="No configuration available"
                  messageId={"cococonfig.errorMessage"}
                  setIsProfileHistoryOpen={setIsProfileHistoryOpen}
                  setSelectedConsent={setSelectedConsent}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ConfigDetailsPopUp
        isProfileHistoryOpen={isProfileHistoryOpen}
        setIsProfileHistoryOpen={setIsProfileHistoryOpen}
        setSelectedData={setSelectedConsent}
        digitalIdentity={details?.digital_identity}
        history={details?.history?.[selectedConsent?.global_purpose]}
        configData={selectedConsent}
      />
    </>
  );
};

export default ConsentProcessing;
